import { render, staticRenderFns } from "./SupplierCashIn.vue?vue&type=template&id=2cbc9836&scoped=true"
import script from "./SupplierCashIn.vue?vue&type=script&lang=js"
export * from "./SupplierCashIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc9836",
  null
  
)

export default component.exports